'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.customersDataRequested = customersDataRequested;
exports.customersDataReceived = customersDataReceived;
exports.customersDataRequestFailed = customersDataRequestFailed;
var CUSTOMERS_DATA_REQUESTED = exports.CUSTOMERS_DATA_REQUESTED = 'CUSTOMERS_DATA_REQUESTED';

function customersDataRequested() {
    return {
        type: CUSTOMERS_DATA_REQUESTED
    };
}

var CUSTOMERS_DATA_RECEIVED = exports.CUSTOMERS_DATA_RECEIVED = 'CUSTOMERS_DATA_RECEIVED';

function customersDataReceived(newCustomersData) {
    return {
        type: CUSTOMERS_DATA_RECEIVED,
        newCustomersData: newCustomersData
    };
}

var CUSTOMERS_DATA_REQUEST_FAILED = exports.CUSTOMERS_DATA_REQUEST_FAILED = 'CUSTOMERS_DATA_REQUEST_FAILED';

function customersDataRequestFailed(error) {
    return {
        type: CUSTOMERS_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/customersDataActions.js
// module id = 202
// module chunks = 0